import React, { useState, useEffect } from "react";
import Navbar from "../../component/Navbar";
import Faq from "../../component/Faq";
import Footer from "../../component/Footer";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import PackageSlick from "./VisitorComp/PackageSlick";
import MobileForm from "./VisitorComp/MobileForm";
import HomeAllPackages from "./VisitorComp/HomeAllPackages";
import { baseurl } from "../../component/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import NavbarVisitorTwo from "./VisitorComp/NavbarVisitorTwo";

function VisitorHome() {
  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState("Package");
  const [packages, setPackages] = useState([]);

  // Fetch packages from API
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}GetAllPackagesNew`);
        if (response.data.packages) {
          setPackages(response.data.packages);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const filteredPackages = packages.filter((pkg) =>
    pkg.package_name.toLowerCase().includes(packageSearchTerm.toLowerCase())
  );

  const togglePackageDropdown = () => setIsPackageOpen(!isPackageOpen);
  const handlePackageSearch = (e) => setPackageSearchTerm(e.target.value);
  const selectPackage = (pkg) => {
    setSelectedPackage(pkg.package_name);
    setPackageSearchTerm(pkg.package_name);
    setIsPackageOpen(false);
  };

  // Initialize the date picker
  React.useEffect(() => {
    $(".datepicker").datepicker({
      dateFormat: "mm/dd/yy", // You can change the format here
    });
  }, []);


  

const navigate = useNavigate(); // Initialize navigation

const handleSubmit = (e) => {
  e.preventDefault(); // Prevent default form submission

  // Construct URL with query parameters
  const queryParams = new URLSearchParams({
    package: selectedPackage,
    checkin: document.querySelector('input[name="from"]').value,
    checkout: document.querySelector('input[name="to"]').value,
  }).toString();

  // Navigate to all-packages page with parameters
  navigate(`/all-package?${queryParams}`);
};




  return (
    <>
      <Navbar />


 


      <div className="m-0 p-0">
        <section>
          <div className="tourz-search">
            <div className="container">
              <div className="row">
                <div className="tourz-search-1">
                  <h1>Plan Your Travel Now!</h1>
                  <p>650+ Travel Agents serving 65+ Destinations worldwide</p>
                  <div className="ban-search form-select pop pop-search ">
                  <form className="hide-on-mobile" onSubmit={handleSubmit}>
  <ul>
    {/* Package Field */}
    <li className="sr-look">
      <div className="form-group">
        <label>Package</label>
        <div className="dropdown-container">
          <input
            type="text"
            className="form-control"
            placeholder="Search package"
            value={packageSearchTerm}
            onChange={handlePackageSearch}
            onClick={togglePackageDropdown}
          />
          {isPackageOpen && (
            <div className="dropdown-list">
              <ul>
                {filteredPackages.map((pkg, index) => (
                  <li key={index} className="w-100 mylist1" onClick={() => selectPackage(pkg)}>
                    {pkg.package_name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </li>

    {/* Age (Check-in) Field */}
    <li className="sr-date">
      <div className="form-group">
        <label>Age</label>
        <input
          type="text"
          className="form-control datepicker"
          name="from"
          autoComplete="off"
          placeholder="Check in"
        />
      </div>
    </li>

    {/* Age (Check-out) Field */}
    <li className="sr-date">
      <div className="form-group">
        <label>Age</label>
        <input
          type="text"
          className="form-control datepicker"
          name="to"
          autoComplete="off"
          placeholder="Check out"
        />
      </div>
    </li>

    {/* Search Button */}
    <li className="sr-btn">
      <input type="submit" value="Search" />
    </li>
  </ul>
</form>


                    {/* form for mobile view only */}
                    <div className="hide-on-desktop">
                      <MobileForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <PackageSlick />

      <HomeAllPackages />

      <Faq />
      <Footer />
    </>
  );
}

export default VisitorHome;
